<div mobile (mobileView)="isMobileView = $event"  class="articles-container row">
  <div class="col-lg-3 col-md-3 col-sm-12 col-xs-12">
    <div class="articles-left-content" role="tablist" aria-label="Articles in this section">
      <ng-template [ngIf]="!isMobileView">
      <h2>Articles in this section</h2>
      <ng-template ngFor let-article [ngForOf]="newsList">
        <!-- <div
          class="catalog-list-item catalog-list-item--clickable"
          (click)="selectedNewsId = article.id"
          [ngClass]="{
            'catalog-list-item--selected': selectedNewsId === article.id
          }"
        >
          {{ article?.title }}
        </div> -->
      <div
  class="catalog-list-item catalog-list-item--clickable"
  [ngClass]="{
  'catalog-list-item--selected': selectedNewsId === article.id
}"
  role="tab"
  [attr.id]="'tab-' + article.id"
  [attr.aria-selected]="selectedNewsId === article.id"
  [attr.tabindex]="selectedNewsId === article.id ? '0' : '-1'"
  [attr.aria-controls]="'panel-' + article.id"
  (click)="selectedNewsId = article.id"
  (keydown.enter)="selectedNewsId = article.id"
  (keydown.space)="selectedNewsId = article.id; $event.preventDefault()"
  (keydown.arrowdown)="moveTab(1)" 
  (keydown.arrowup)="moveTab(-1)">
  {{article.title}}
</div>
        
      </ng-template>
      </ng-template>
      <ng-template [ngIf]="isMobileView">
        <div class="form-group stretch">
          <mat-form-field>
            <mat-label>Articles in this section</mat-label>
              <mat-select
                  disableOptionCentering
                  [(ngModel)]="selectedNewsId"
                  name="mediaArticle"
                  #mediaArticle="ngModel"
                  (selectionChange)="onSelectionChange($event)"
              >
                  <mat-option
                      *ngFor="let article of newsList"
                      [value]="article.id" >
                  {{ article?.title }}
                  </mat-option>
              </mat-select>
          </mat-form-field>
      </div>
      </ng-template>
    </div>
  </div>
  <div class="col-lg-9 col-md-9 col-sm-12 col-xs-12">
    <div *ngIf="newsMap[selectedNewsId]" class="articles-right-content" role="tabpanel" [attr.id]="'panel-' + selectedNewsId" [attr.aria-labelledby]="'tab-' + selectedNewsId">
      <h3>{{ newsMap[selectedNewsId]["title"] }}</h3>
      <div class="article-history align-h margin-top-35 margin-bottom-35">
        <div class="article-history-updated stretch">{{newsMap[selectedNewsId]["translatedModifiedDate"]}}</div>
        <ng-template [ngIf]="!isMobileView">
        <div class="article-history-sharing">
          <h4>Share article to</h4>
          <ul class="social-share-list">
          <a
            href="https://www.facebook.com/sharer/sharer.php?u={{ pageUrl }}"
            target="_blank"
          >
            <img src="assets/svg/Facebook.svg" alt="facebook" />
          </a>
          <a href="https://twitter.com/share?url={{ pageUrl }}" target="_blank">
            <img src="assets/icons/X.png" alt="twitter" />
          </a>
          <a
            href="https://www.linkedin.com/shareArticle?url={{ pageUrl }}"
            target="_blank"
          >
            <img src="assets/svg/LinkedIN.svg" alt="linkedin" />
          </a>
          </ul>
        </div>
        <button
        *ngIf="newsMap[selectedNewsId]['pdfUrl'] && !inProgress"
          type="button"
          class="btn btn-primary btn-lg pdf-button"
          (click)="downloadAsPDF(newsMap[selectedNewsId]['pdfUrl'])"
        >
          <span class="article-history-pdf-download">
            <img src="assets/svg/pdf-file.svg" alt="pdf" />
          </span>
          Download
        </button>
        <mat-spinner *ngIf="inProgress"  [diameter]="25"></mat-spinner>
      </ng-template>
      <ng-template [ngIf]="isMobileView">
        <div class="article-history-sharing--mobile">
          <ul class="social-share-list">
          <li>
          <a
          href="https://www.facebook.com/sharer/sharer.php?u={{ pageUrl }}"
          target="_blank">
          <img src="assets/svg/Facebook.svg" alt="facebook" />
        </a>
        </li>
        </ul>
        </div>
      <span *ngIf="newsMap[selectedNewsId]['pdfUrl'] && !inProgress" class="article-history-pdf-download--mobile"  (click)="downloadAsPDF(newsMap[selectedNewsId]['pdfUrl'])">
        <img src="assets/svg/pdf-file.svg" alt="pdf" />
      </span>
      <mat-spinner *ngIf="inProgress"  [diameter]="25"></mat-spinner>
       </ng-template>
      </div>
      <div class="article-image" *ngIf="newsMap[selectedNewsId]['imagePath']">
        <img
          [src]="newsMap[selectedNewsId]['imagePath']"
          [alt]="newsMap[selectedNewsId]['title']"
        />
      </div>
      <div class="article-image" *ngIf="newsMap[selectedNewsId]['video']">
        <iframe class="article-vedio-iframe" [src]="getSafeUrl(newsMap[selectedNewsId]['video'])" frameborder="0"
        allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen>
      </iframe>
      </div>
      <p
        class="article-html-content margin-top-35 margin-bottom-35"
        [innerHTML]="newsMap[selectedNewsId]['htmlContent']"
      ></p>
    </div>
  </div>
</div>
